/**
 * Creates a function which will rate-limit the callBack function with a specific debounce value
 *
 * @param callBack
 * @param debounce
 * @returns {Function}
 */
export const createDebounce = function (callBack, debounce) {
  debounce = debounce || 100;

  var timeOut;

  return function () {
    if (timeOut) {
      clearTimeout(timeOut);
    }

    timeOut = setTimeout(() => {
      callBack.apply(this, arguments);
    }, debounce);
  };
};
